import { ref } from 'vue'

export const homeTrigger = ref({
    id: 0,
    params: null
})

export function triggerHome(params) {
    homeTrigger.value = {
        id: homeTrigger.value.id + 1,
        params
    }
}
